import { JSX, PropsWithChildren } from 'react'
import { Flex } from '@chakra-ui/react'

type Props = {
  color: string
}

const InfoTag = ({ color, children }: PropsWithChildren<Props>): JSX.Element => {
  return (
    <Flex
      justifyContent="center"
      alignItems="center"
      width="100%"
      padding="10px"
      gridGap="10px"
      borderRadius="big"
      background={color}
    >
      {children}
    </Flex>
  )
}

export default InfoTag
